import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import NonAuth from './Layout/NonAuth';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AuthRoute, PageRoute } from './Router';
import { ToastContainer } from 'react-toastify';
import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import Page404 from './Error/page404';
import ErrorBoundry from './Error/ErrorBoundry';


function App() {
  return (
    <div className="App">
      <ToastContainer />
      <ErrorBoundry>
        <Suspense fallback={<div>Loading ..</div>}>
          <Routes>
            {AuthRoute.map((e, i) => {
              return (<Route key={i} path={e.path} element={e.element} />)
            })
            }
            {PageRoute.map((e, i) => {
              return (<Route key={i} path={e.path} element={<AuthorizedRoute element={e.element} />} />)
            })
            }
            <Route path="*" element={<Page404 />} />
          </Routes>

        </Suspense>
      </ErrorBoundry>
    </div>
  );
}


const AuthorizedRoute = ({ element }) => {
  let Layout;
  const location = useLocation()
  const path = location.pathname
  const isAuthenticated = useSelector((state) => {
    Layout = NonAuth;
    return state.auth.isAuthenticate
  });
  if (path === '/auth') {
    return isAuthenticated ? <Navigate to={'/'} /> : <Navigate to={`/auth`} />;
  } else if (path === '/') {
    return <Layout>{element}</Layout>
  } else {
    return isAuthenticated ? <Layout>{element}</Layout> : <Navigate to={`/auth`} />;
  }

}

export default App;
